import { I18n } from '@calendly/i18n'

export const filterEventTypes = (profilesWithEventTypes, filter) => {
  if (!profilesWithEventTypes) return []
  return profilesWithEventTypes
    .map((profile) => ({
      ...profile,
      eventTypes: profile.eventTypes.filter(filter)
    }))
    .filter((profile) => profile.eventTypes.length > 0)
}

export const filterEventTypesByText = (profilesWithEventTypes, searchTerm) => {
  if (!searchTerm) return profilesWithEventTypes
  return filterEventTypes(
    profilesWithEventTypes,
    ({ name }) => name.toLowerCase().includes(searchTerm.toLowerCase())
  )
}

export const setEditPermissions = (profilesWithEventTypes, ownerName, managerCount) => {
  if (!profilesWithEventTypes) return []

  return profilesWithEventTypes.map((profile) => {
    const overrideHint = I18n.t('publisher.availability.schedules.tooltip.edit_override')
    const permissionTeamHint = I18n.t('publisher.availability.schedules.tooltip.managed_by_team')
    const permissionOwnerHint = I18n.t('publisher.availability.schedules.tooltip.managed_by_owner', { owner_name: ownerName })

    const eventTypes = profile.eventTypes.map((eventType) => {
      let canEdit = true
      let hint = ''

      if (!eventType.policy.edit) {
        canEdit = false
        hint = managerCount > 1 ? permissionTeamHint : permissionOwnerHint
      } else if (eventType.availabilityOverride) {
        canEdit = false
        hint = overrideHint
      }

      return {
        ...eventType,
        canEdit,
        editLockedHint: hint
      }
    })
    return { ...profile, eventTypes }
  })
}
